import React from 'react';

const Key: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="17"
    fill="none"
    viewBox="0 0 16 17"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d={`M15.5 6.03125C15.5 7.45703 14.9922 8.67773 13.9766 9.69336C12.9805
        10.6895 11.7695 11.1875 10.3438 11.1875C10.0117 11.1875 9.68945
        11.1582 9.37695 11.0996L8.67383 11.8906C8.53711 12.0469 8.36133
        12.125 8.14648 12.125H7.0625V13.2969C7.0625 13.4922 6.99414 13.6582
        6.85742 13.7949C6.7207 13.9316 6.55469 14 6.35938 14H5.1875V15.1719C5.187
        15.3672 5.11914 15.5332 4.98242 15.6699C4.8457 15.8066 4.67969 15.875
        4.48438 15.875H1.20312C1.00781 15.875 0.841797 15.8066 0.705078
        15.6699C0.568359 15.5332 0.5 15.3672 0.5 15.1719V12.8867C0.5 12.6914
        0.568359 12.5254 0.705078 12.3887L5.45117 7.64258C5.27539 7.11523
        5.1875 6.57812 5.1875 6.03125C5.1875 5.09375 5.41211 4.23438 5.86133
        3.45312C6.33008 2.65234 6.95508 2.02734 7.73633 1.57812C8.53711 1.10938
        9.40625 0.875 10.3438 0.875C11.7695 0.875 12.9805 1.38281 13.9766
        2.39844C14.9922 3.39453 15.5 4.60547 15.5 6.03125ZM10.7539 3.62891C10.4805
        3.90234 10.3438 4.23438 10.3438 4.625C10.3438 5.01562 10.4805 5.34766
        10.7539 5.62109C11.0273 5.89453 11.3594 6.03125 11.75 6.03125C12.1406
        6.03125 12.4727 5.89453 12.7461 5.62109C13.0195 5.34766 13.1562 5.01562
        13.1562 4.625C13.1562 4.23438 13.0195 3.90234 12.7461 3.62891C12.4727
        3.35547 12.1406 3.21875 11.75 3.21875C11.3594 3.21875 11.0273 3.35547
        10.7539 3.62891Z`} fill="#C5D0DE"
    />
  </svg>
);

export default Key;